import { render, staticRenderFns } from "./oilApplication.vue?vue&type=template&id=df88b494&scoped=true"
import script from "./oilApplication.vue?vue&type=script&lang=js"
export * from "./oilApplication.vue?vue&type=script&lang=js"
import style0 from "./oilApplication.vue?vue&type=style&index=0&id=df88b494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df88b494",
  null
  
)

export default component.exports